import { useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";

export default function Logout() {
  const navigate = useNavigate();
  const BASE_URL = useOutletContext();

  useEffect(() => {
    fetch(`${BASE_URL}/logout.php`, {
      method: "POST",
      credentials: "include" // 👈 necesario para enviar y borrar la cookie
    })
      .then(() => {
        navigate("/"); // ✅ redirige al login después del logout
      })
      .catch((err) => {
        console.error("Error cerrando sesión:", err);
        navigate("/"); // Igual redirige aunque haya error
      });
  }, [navigate, BASE_URL]);

  return null;
}
